<template>
  <md-tab id="tab-market-area" md-label="Market Area" md-icon="map">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 order-2"
      >
      <PulseLoader
      :loading="loading"
      :class="{ hide: !loading }"
      quote="Action is the foundational key to all success"
      author="Pablo Picasso"
      profession="Spanish Painter"
      img="picasso.jpg"
    ></PulseLoader>
        <div
          :key="componentKey"
          v-if="loaded && searchMarketAreas == null && !searchLoadingMarketArea"
        >
          <div @click="chooseAllUS($event)" :class="checkUS()?'US-9999 available':'US-9999 unavailable'">
            ALL US
          </div>
          <div
            v-for="(title, stateId) in markets"
            :key="stateId"
            @click="chooseMarket($event)"
            :class="
              `${removeSpaces(Object.keys(title[0])[0])} [${stateId}] ${
                availableMarkets.includes(Object.keys(title[0])[0]) && checkStates()
                  ? 'available'
                  : 'unavailable'
              } unclicked correct-padding `
            "
          >
            {{ Object.keys(title[0])[0] }}
          </div>
        </div>
        <!-- <div>
          <pulse-loader
            :color="'blue'"
            :loading="searchLoadingMarketArea && searchMarketAreas == null"
          ></pulse-loader>
        </div> -->
        <div v-if="searchMarketAreas != null">
          <div v-if="searchMarketAreas[0] == 0" class="available">
            No results! Please try different keyword.
          </div>
          <div
            v-for="(searchMarket, searchIndex) in searchMarketAreas[0]"
            :key="searchIndex + 'collapse'"
            :class="
              `search-${getData(searchMarket)} ${
                searchMarketAreas[1].includes(searchMarket)
                  ? 'available'
                  : 'unavailable'
              } `
            "
            @click="chooseSearchResult($event)"
          >
            {{ getName(searchMarket) }}
          </div>
        </div>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 search_panel"
      >
        <sidebar-search @load-area="loadArea" tab="market_area" title="Favorite Market Areas" />
      </div>
    </div>
  </md-tab>
</template>

<script>
import SidebarSearch from './../_partials/SidebarSearch';
import axios from 'axios';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import {PulseLoader} from '@/components';
import Vue from 'vue';

export default {
  name: 'market-area-tab',
  props: {},
  components: {
    SidebarSearch,
    PulseLoader,
  },
  data() {
    return {
      search: 'autofill text area names...',
      apiMarkets: undefined,
      markets: {},
      availableMarkets: [],
      loaded: false,
      componentKey: 0,
      loading: false,
      route: null,
    };
  },
  methods: {
    checkCounties: function(){
      if(this.$store.getters['user/userAccess'])
        if(this.$store.getters['user/userAccess'].ifpAccess.geo_counties)
          return true;
        else
          return false;
      else
        return true;
    },
    checkMetros: function(){
      if(this.$store.getters['user/userAccess'])
        if(this.$store.getters['user/userAccess'].ifpAccess.geo_metros)
          return true;
        else
          return false;
      else
        return true;
    },
    checkUS: function(){
      if(this.$store.getters['user/userAccess'])
        if(this.$store.getters['user/userAccess'].ifpAccess.geo_national)
          return true;
        else
          return false;
      else
        return true;
    },
    checkZIPS: function(){
      if(this.$store.getters['user/userAccess'])
        if(this.$store.getters['user/userAccess'].ifpAccess.geo_zips)
          return true;
        else
          return false;
      else
        return true;
    },
    checkStates: function(){
      if(this.$store.getters['user/userAccess'])
        if(this.$store.getters['user/userAccess'].ifpAccess.geo_states)
          return true;
        else
          return false;
      else
        return true;
    },
    loadArea: function (e){
      this.loaded = !e.isLoading;
    },
    removeSpaces: function(name) {
      return name.replace(/\s/g, '').replace(/,/g, ' ');
    },
    getData: function(name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },
    getName: function(name) {
      if (name) {
        return name.split('[')[0];
      }
    },
    chooseSearchResult: function(event) {
      const id = event.target.className.split(' ')[0].split('-')[1];
      const title = this.getName(event.target.innerText);
      this.$store.commit('SET_MARKET_AREA', `${title} [${id}]`);
    },

    getMarkets: async function() {
      await axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/areas', {
          params: {
            type: 'if',
            industry: '0',
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          this.apiMarkets = res.data.data;
          this.apiMarkets.forEach((market) => {
            if (Object.keys(this.markets).includes(`${market.state_id}`)) {
              let temp = {};
              temp[market.area] = market.metro_id;
              this.markets[market.state_id].push(temp);
            } else {
              let temp = {};
              temp[market.area] = market.metro_id;
              this.markets[market.state_id] = [temp];
            }
          });
          this.loaded = true;
        });

      await this.getAvailableMarkets();
    },
    async chooseAllUS(event) {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      event.stopPropagation();
      this.$store.commit('SET_MARKET_AREA', 'US [9999]');

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              area: this.getData(this.marketArea),
              profile_id: this.profileId ? this.profileId : '0',
              type:
                this.$store.getters.type === 'Industry firms' ? 'if' : 'spif',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('SET_PROFILE_ID', id);
        });
    },
    chooseMarket: async function(event) {
      let query = event.target.className;
      let title = query.split(' ')[0];
      let id = this.getData(query);
      let currentDiv = document.getElementsByClassName(`${title} [${id}]`)[0];
      if (!query.includes(',')) {
        let loadingDiv = document.createElement('div');
        let loadingMount = document.createElement('div');

        loadingDiv.setAttribute('class', 'available');
        loadingDiv.appendChild(loadingMount);

        currentDiv.appendChild(loadingDiv);

        if (title !== 'US') {
          const pulseLoader = Vue.extend(PulseLoader);
          const pulseLoaderToMount = new pulseLoader({
            propsData: {
              color: 'blue',
              loading: true,
            },
          }).$mount(loadingMount);
        }
      } else {
        title = query.split(',')[0];
      }

      this.$store.commit('SET_MARKET_AREA', `${title} [${id}]`);

      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + this.route,
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.profileId ? this.profileId : '0',
              industry: this.getData(this.industry),
              sales_class: this.getData(this.salesClass),
              area: this.getData(this.marketArea),
              years: this.$store.getters.years,
              type:
                this.$store.getters.type === 'Industry firms' ? 'if' : 'spif',
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + ${this.route} <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          const { id } = res.data;
          this.$store.commit('SET_PROFILE_ID', id);
        });
      if (title !== 'US' && currentDiv) {
        if (currentDiv.classList.contains('unclicked')) {

          currentDiv.classList.remove('unclicked');
          currentDiv.classList.add('clicked');

          while (currentDiv.firstChild != currentDiv.lastChild) {
            currentDiv.removeChild(currentDiv.lastChild);
          }
          if(this.markets[id])
            this.markets[id].slice(1).forEach((market) => {
              let elementToAppend = document.createElement('div');
              elementToAppend.setAttribute(
                'class',
                `${this.removeSpaces(Object.keys(market)[0])} [${
                  Object.values(market)[0]
                }] available collapsed`
              );
              elementToAppend.textContent = `${Object.keys(market)[0]}`;
              document.getElementsByClassName(`${title} [${id}]`)[0].appendChild(elementToAppend);
            });

        } else {

          while (currentDiv.firstChild != currentDiv.lastChild) {
            currentDiv.removeChild(currentDiv.lastChild);
          }
          currentDiv.classList.remove('clicked');
          currentDiv.classList.add('unclicked');
        }
      }

      await this.getAvailableMarkets();
    },
    getAvailableMarkets: async function() {
      let temp = [];

      await axios
        .get(process.env.VUE_APP_API_BASE_URL + '/info/areas', {
          params: {
            type: 'if',
            industry: this.getData(this.industry),
          },
        })
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          this.apiMarkets = res.data.data;
          this.apiMarkets.forEach((market) => {
            if (market.metro_id == 0) {
              temp.push(market.area);
            }
          });
        });

      this.availableMarkets = temp;
    },
  },
  async created() {

      if (this.$route.name === 'NewProfile')
        this.route = '/user/search_profiles/if';
      else
        this.route = '/user/search_reports/if';

    await this.getMarkets();

  },
  computed: {
    profileId() {
      return this.$store.getters.profileId;
    },
    industry() {
      return this.$store.getters.industry;
    },
    marketArea() {
      return this.$store.getters.marketArea;
    },
    salesClass() {
      return this.$store.getters.salesClass;
    },
    searchMarketAreas() {
      return this.$store.getters.searchMarketAreas;
    },
    searchLoadingMarketArea() {
      return this.$store.getters.searchLoadingMarketArea;
    },
  },
  watch: {
    industry(newValue, oldValue) {
      this.getAvailableMarkets();
      this.componentKey = newValue;
    },
    searchMarketAreas(){
    }
  },
};
</script>
<style lang="scss">
.unavailable {
  opacity: 0.5;
  color: #3c4858;
  font-size: 0.9375rem;
  cursor: not-allowed;
  margin: 16px;
}
.available {
  color: #3c4858;
  font-size: 0.9375rem;
  cursor: pointer;
  margin: 16px;
}
.correct-padding {
  padding-left: 16px;
}
.available:hover {
  color: #1a7bfa;
}
</style>